import * as DateFns from 'date-fns'
const dates = {
  futureDate(date) {
    return DateFns.isFuture(new Date(date));
  },
  futureDateTime(dateTime) {
    return DateFns.isFuture(dateTime);
  },
  pastDate(date) {
    return DateFns.isPast(new Date(date));
  },
  pastDateTime(dateTime) {
    return DateFns.isPast(dateTime);
  },
  timeToNow(dateTime) {
    return DateFns.formatDistanceToNowStrict(dateTime);
  },
  diffDays(dateTime1, dateTime2) {
    return DateFns.differenceInDays(dateTime1, dateTime2);
  },
  diffMinutes(dateTime1, dateTime2) {
    return DateFns.differenceInMinutes(dateTime1, dateTime2);
  },
  addTime(dateTime, time) {
    return DateFns.add(dateTime, time);
  },
  subtractTime(dateTime, time) {
    return DateFns.sub(dateTime, time);
  },
  jsonDateToLocaleDate(string, outputLocale) {
    let date = DateFns.parseJSON(string);
    return DateFns.intlFormat(date, {locale: outputLocale});
  },
  jsonDateToLocaleDateTime(string, outputLocale) {
    let date = DateFns.parseJSON(string);
    return DateFns.intlFormat(
      date,
      {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      },
      {locale: outputLocale});
  },
  jsonDateToLocaleDateTimeNS(string, outputLocale, timezone) {
    let date = DateFns.parseJSON(string);
    return DateFns.intlFormat(
      date,
      {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: timezone
      },
      {locale: outputLocale});
  },
  jsonDateToMonthYear(string) {
    let date = DateFns.parseJSON(string);
    return DateFns.format(date, 'MMMM yyyy');
  },
  jsonDateToLocaleTime(string, outputLocale) {
    let date = DateFns.parseJSON(string);
    return DateFns.intlFormat(
      date,
      {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      },
      {locale: outputLocale});
  },
  isoString(date = null) {
    let target = date ?? new Date();
    return DateFns.formatISO(target);
  },
  parseISOString(string) {
    return DateFns.parseISO(string);
  },
  getTimestamp(date = null) {
    let target = date ?? new Date()
    return DateFns.getUnixTime(target);
  },
  parseJsonDate(string) {
    return DateFns.parseJSON(string);
  },
  toYMD(dateTime) {
    return DateFns.format(dateTime, 'yyyy-MM-dd');
  },
  isValid(target) {
    return DateFns.isValid(target);
  }
};

export default dates;
